import breadcrumb from './breadcrumb';
import navbar from './navbar';
import notes from './notes';

const module = angular.module('app.directives', []);

module.directive('breadcrumb', breadcrumb);
module.directive('navbar', navbar);
module.directive('notes', notes);

export default module;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/directives/index.js